import { DomainV2 } from 'troppus-common/domain';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

const LABEL_BY_TYPE: Record<ImportTableDefinition.SchemaJson.Column['type'], string> = {
  string: '文字列',
  number: '数値',
  date: '日付',
  boolean: '真偽値',
};

export function importTableDefinitionColumnTypeLabel(type: ImportTableDefinition.SchemaJson.Column['type']): string {
  return LABEL_BY_TYPE[type];
}
